import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, QueryList, ElementRef } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { ToolsService } from 'src/app/services/tools.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ModalController } from '@ionic/angular';
import { ModalCodeQuestionPage } from 'src/app/modals/modal-code-question/modal-code-question.page';
export class FormComponent {
    constructor(toolsService, authService, router, configService, modalController) {
        this.toolsService = toolsService;
        this.authService = authService;
        this.router = router;
        this.configService = configService;
        this.modalController = modalController;
        this.submit = new EventEmitter();
        this.noImage = true;
        this.myControl = new FormControl();
        this.loadingAutocomplete = false;
        this.loadingSelect = false;
    }
    filterDynamicOptions(question, level, index) {
        // index: corresponde al id del campo ej razon xsocial = 0, ciudad = 1, punto de venta = 2;
        // level: corresponde al campo actual
        // question: es el formulario completo
        const currentSearchTerm = level.control.value.toLowerCase();
        let filteredOptions = level.options.filter(option => option.name.toLowerCase().includes(currentSearchTerm));
        if (index > 0) {
            if (index === 1) {
                this.prevValue = currentSearchTerm
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase();
            }
            const previousSelectedValues = question.levels[index - 1].searchTerm === ""
                ? []
                : (question.levels[index - 1].filtered_options || []).map(opt => opt.value);
            let filteredPreviousValues = [];
            if (this.prevValue) {
                filteredPreviousValues = previousSelectedValues.filter(value => value.normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()
                    .includes(this.prevValue));
            }
            const selectedValues = filteredPreviousValues.length > 0
                ? filteredPreviousValues
                : previousSelectedValues;
            filteredOptions = level.options.filter(option => option.condition.some(condition => selectedValues.includes(condition)));
        }
        level.filtered_options = filteredOptions;
        level.searchTerm = currentSearchTerm.toUpperCase();
    }
    onDynamicSelectChange(question, levelIndex) {
        if (!question.levels)
            return;
        if (levelIndex + 1 < question.levels.length) {
            const nextLevel = question.levels[levelIndex + 1];
            nextLevel.searchTerm = '';
            this.filterDynamicOptions(question, nextLevel, levelIndex + 1);
            for (let i = levelIndex + 1; i < question.levels.length; i++) {
                question.levels[i].control.setValue('');
                if (i !== levelIndex + 1) {
                    this.filterDynamicOptions(question, question.levels[i], i);
                }
            }
        }
        for (let i = question.levels.length - 1; i >= 0; i--) {
            const val = question.levels[i].control.value;
            if (val) {
                question.formControl.setValue(val);
                break;
            }
        }
    }
    onDynamicSelectOpen(index, opened) {
        if (opened) {
            setTimeout(() => {
                const inputs = this.dynamicSelectInputs.toArray();
                if (inputs && inputs[index]) {
                    inputs[index].nativeElement.focus();
                }
            });
        }
    }
    ngOnInit() {
        this.passwordField = this.validQuestions.find(q => q.label === 'Contraseña');
    }
    togglePasswordVisibility(question) {
        question.showPassword = !question.showPassword;
        question.inputType = question.showPassword ? 'text' : 'password';
    }
    get validQuestions() {
        if (!this.questions)
            return [];
        return this.questions.filter((question) => question.is_active !== false);
    }
    isFormValid(question) {
        // Ensure validQuestions[0].formControl.value and validQuestions[1]?.formControl.value are strings
        const value1 = this.validQuestions[0] && this.validQuestions[0].formControl && this.validQuestions[0].formControl.value;
        const value2 = this.validQuestions[1] && this.validQuestions[1].formControl && this.validQuestions[1].formControl.value;
        if (typeof value1 !== 'string' || typeof value2 !== 'string') {
            return false;
        }
        // Perform the necessary checks
        const condition1 = value1.includes(value2);
        const condition2 = value2.length > 0;
        const condition3 = question.type === 'password';
        const condition4 = this.validQuestions.length > 2;
        return condition1 && condition2 && condition3 && condition4;
    }
    searchOptions(name, question) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (question.search_url) { //Filtering using django
                this.searchDjango(name, question);
            }
            else { //Filtering using javacript
                this.searchJS(name, question);
            }
        });
    }
    //Filtering using JS
    searchJS(name, question) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loadingAutocomplete = true;
            if (!question.options && question.options_url)
                question.options = yield this.configService.getOptions(question);
            if (name == '')
                question.filtered_options = question.options;
            else {
                question.filtered_options = question.options.filter(res => res.name.toLowerCase().includes(name.toLowerCase()));
            }
            this.loadingAutocomplete = false;
            if (question.filtered_options.length == 0)
                question.filtered_options = [{ name: 'No hay sugerencias disponibles', value: '0' }];
        });
    }
    //Function to filter options using django
    searchDjango(name, question) {
        var current_value = question.formControl.value;
        setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (current_value != name) {
                this.loadingAutocomplete = false;
                return;
            }
            else {
                this.loadingAutocomplete = true;
                var result = yield this.configService.filterOptions(name, question.search_url);
                question.filtered_options = result.results;
                this.loadingAutocomplete = false;
                if (question.filtered_options.length == 0)
                    question.filtered_options = [{ name: 'No hay sugerencias disponibles', value: '0' }];
            }
        }), 500);
    }
    previewFile(question) {
        if (this.image.files.length === 0)
            return;
        var mimeType = this.image.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            this.toolsService.showErrorToast("Has subido una imagen inválida");
            return;
        }
        var reader = new FileReader();
        this.imagePath = this.image.files;
        reader.readAsDataURL(this.image.files[0]);
        reader.onload = (_event) => {
            this.optimizeImg(reader.result).then((res) => {
                question.src = [res];
            });
        };
    }
    previewPDF(question) {
        if (question.formControl.value._files.length === 0)
            return;
        var mimeType = question.formControl.value._files[0].type;
        if (mimeType.match(/application\/pdf/) == null) {
            this.toolsService.showErrorToast("Has subido un archivo PDF inválido");
            return;
        }
        var reader = new FileReader();
        this.filePath = question.formControl.value._files;
        reader.readAsDataURL(question.formControl.value._files[0]);
        reader.onload = (_event) => {
            /* question.src.push(reader.result); */
            question.src = [reader.result];
        };
    }
    //FUnction to delete image
    deleteImg(question, image) {
        const index = question.src.indexOf(image, 0);
        if (index > -1) {
            question.src.splice(index, 1);
        }
        if (question.src.length == 0)
            question.formControl.setValue('');
    }
    //FUnction to delete image
    deleteFile(question, image) {
        const index = question.src.indexOf(image, 0);
        if (index > -1) {
            question.src.splice(index, 1);
        }
        if (question.src.length == 0)
            question.formControl.setValue('');
    }
    //Function to execute the event of the page 
    submitForm() {
        console.log(this.questions);
        this.submit.emit();
    }
    //Function to duplicate a field
    addResponse(question) {
        var newQuestion = question.format != 'group' ? Object.assign({}, question, { formControl: new FormControl('', question.formControl.validator) }) : Object.assign({}, question, { questions: this.copyArray(question.questions) });
        question['copied'] = true;
        question.multiple_response = false;
        var index = this.questions.indexOf(question);
        if (index == this.questions.length - 1) //if it is the last question
            this.questions.push(newQuestion);
        else
            this.questions.splice(index + 1, 0, newQuestion);
    }
    isRequired(formControl) {
        const validator = formControl.validator({});
        if (validator && validator.required) {
            return true;
        }
    }
    copyArray(questions) {
        var copy = [];
        for (let single_question of questions)
            copy.push(Object.assign({}, single_question, { formControl: new FormControl('', single_question.formControl.validator) }));
        return copy;
    }
    //Function to remove a duplicated field
    removeResponse(question) {
        var index = this.questions.indexOf(question);
        this.questions.splice(index, 1);
    }
    displayFn(option) {
        return option && option.name ? option.name : '';
    }
    //Function to check if select field has options
    checkOptions(question) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loadingSelect = true;
            if (!question.options && question.options_url)
                question.options = yield this.configService.getOptions(question);
            this.loadingSelect = false;
        });
    }
    //Function to reset show when
    reset_show_when(initial_question) {
        if (!initial_question.reset_show_when)
            return;
        for (let question of this.questions)
            if (question.show_when && question.show_when == initial_question.formControl) {
                question.options = null;
                question.formControl.setValue('');
                this.reset_show_when(question);
            }
    }
    //Function to open code modal
    presentCodeModal(question) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: ModalCodeQuestionPage
            });
            modal.onDidDismiss()
                .then((response) => {
                if (response.data) {
                    console.log(response.data);
                    question.formControl.setValue(response.data);
                }
            });
            return yield modal.present();
        });
    }
    //Function to optmize imgs
    optimizeImg(result) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.configService.resizeImage(result, 1280, 1280);
        });
    }
    onChangeEvent(event, question) {
        if (question.type == "email") {
            var current_value = question.formControl.value;
            var no_spaces_value = current_value.replace(/\s/img, '');
            question.formControl.setValue(no_spaces_value);
        }
    }
}
